<template>
  <div class="v-dialog" >
    <el-dialog
      :close-on-click-modal="closeOnclickModal"
      :close-on-press-escape="false"
      :show-close="showClose"
      :visible.sync="dialogVisible"
      :width="width"
      :fullscreen="fullscreen"
      :modal="modal"
      :append-to-body="appendToBody"
      :class="{'has-append-body':appendToBody}"
      @opened="opened"
      @closed="handleClosed"
      @open="handleOpen">
      <slot></slot>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'VDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '500px'
    },
    closeOnclickModal: {
      type: Boolean,
      default: false
    },
    fullscreen:{
      type: Boolean,
      default: false
    },
    modal:{
      type: Boolean,
      default: true
    },
    appendToBody:{
      type: Boolean,
      default: false
    },
    showClose:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogVisible: this.value
    }
  },
  watch: {
    value(val) {
      if(val !== this.dialogVisible) {
        this.dialogVisible = val
      }
    },
    dialogVisible(status) {
      this.$emit('input', status)
    }
  },
  methods:{
    handleOpen(){
      this.$emit('open')
    },
    handleClosed(){
      this.$emit('closed')
    },
    opened(){
      this.$emit('opened')
    }
  }
}
</script>
<style lang="scss" scoped>
.v-dialog {
  & /deep/ .el-dialog__header {
    padding: 0;
  }
  & /deep/ .el-dialog__body {
      padding: 0;
  }
  &.has-append-body{
    background: #000;
  }
}
.has-append-body{
  & /deep/ .el-dialog__header {
    padding: 0;
  }
  & /deep/ .el-dialog__body {
    padding: 0;
  }
}
</style>
